import React from 'react';
import { Button } from '../ui/Button';
import { SelectField, TextAreaField, TextField } from '../ui/Field';
import { FormCard, FormError, FormFooterNote, FormSuccess } from './FormShell';
import { useLeadSubmit } from '../../hooks/useLeadSubmit';
const motivos = ['Quiero comprar un auto', 'Quiero vender mi auto', 'Quiero financiar', 'Tengo una permuta', 'Busco un 0KM', 'Otra consulta'];
export function ConsultaForm({
  motivoInicial = '',
  vehiculoInicial = '',
  title = 'Dejá tu consulta',
  lead = 'Contanos qué vehículo buscás o qué operación querés realizar y un asesor te responde.'
}: {
  motivoInicial?: string;
  vehiculoInicial?: string;
  title?: string;
  lead?: string;
}) {
  const {
    status,
    sending,
    submitted,
    reference,
    submitForm,
    retry
  } = useLeadSubmit('consulta', 'Consulta');
  if (submitted) {
    return <FormSuccess message="Gracias por tu consulta. Un asesor de VCARS se comunicará con vos a la brevedad." reference={reference} data-id="element-104" data-mp="3qdab873j970b" />;
  }
  return <FormCard title={title} lead={lead} data-id="element-105" data-mp="tmvivh79x975">
      {status === 'error' ? <FormError onRetry={retry} data-id="element-106" data-mp="oly2na5tqp8a" /> : null}
      <form className="grid gap-4 sm:grid-cols-2" onSubmit={submitForm} data-id="element-107" data-mp="okwfw8fg4eaq">
        <TextField id="nombre" label="Nombre y apellido" required autoComplete="name" data-id="element-108" data-mp="jnw89t2y73hi" />
        <TextField id="telefono" label="Teléfono" type="tel" required autoComplete="tel" data-id="element-109" data-mp="fmawkb25gv8w" />
        <TextField id="email" label="Email" type="email" required autoComplete="email" data-id="element-110" data-mp="1cc1u6j5qmyix" />
        <SelectField id="motivo" label="Motivo de consulta" options={motivos} defaultValue={motivoInicial} required data-id="element-111" data-mp="17c73aflyq8xv" />
        <TextField id="vehiculoInteres" label="Marca / modelo de interés" className="sm:col-span-2" defaultValue={vehiculoInicial} placeholder="Ej: Toyota Hilux SRX" data-id="element-112" data-mp="12jmextltso1q" />
        <TextAreaField id="mensaje" label="Mensaje" className="sm:col-span-2" required data-id="element-113" data-mp="1qb1h9mdlr5cz" />
        <div className="sm:col-span-2" data-id="element-114" data-mp="3kjowa3cd4b04">
          <Button type="submit" size="lg" className="w-full sm:w-auto" disabled={sending} data-id="element-115" data-mp="3kkq5s3dqcpfq">
            {sending ? 'Enviando consulta…' : 'Enviar consulta'}
          </Button>
          <FormFooterNote data-id="element-116" data-mp="3audpincy7ife">
            Atención personalizada para encontrar el vehículo ideal. Respondemos en el día.
          </FormFooterNote>
        </div>
      </form>
    </FormCard>;
}